/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */

import './mobile.css';

import angular from 'angular';
import gmfControllersAbstractMobileController, {
  AbstractMobileController,
} from 'gmf/controllers/AbstractMobileController.js';
import gr_mapfish3Base from './gr_mapfish3module.js';
import webComponents from '../webcomponents/index';
import {initializeLocale, updateLanguageSwitcher} from './commons/localize.js';

/**
 * @private
 */
class Controller extends AbstractMobileController {
  constructor($scope, $injector) {
    super($scope, $injector);
    initializeLocale(this.lang);
    updateLanguageSwitcher($scope, {lang: this.lang});
  }
  
  // AngularJS calls this automatically once all properties are loaded
  $onInit() {
    // Handle redirectBaseUrl
    if (this.redirectUrl) {
      try {
        const parsedUrl = new URL(this.redirectUrl);
        this.redirectBaseUrl = parsedUrl.origin;
      } catch (e) {
        this.redirectBaseUrl = this.redirectUrl.split(/[?#]/)[0];
      }
    } else {
      this.redirectBaseUrl = '';
    }
  }
}

/**
 * @hidden
 */
const gr_mapfish3Module = angular.module('Mobile', [
  gr_mapfish3Base.name,
  gmfControllersAbstractMobileController.name,
  webComponents.name,
]);

gr_mapfish3Module.controller('MobileController', Controller);

export default gr_mapfish3Module;
